import Fetcher from "../../../services/fetcher";
import settings from "../../../settings";

const updateBestOf = (bestOf: any, titleBestoff: any, allDayBestOf: any, postByDay: any,  postCover: any, isPublish: any): Promise<any> => {
  return Fetcher.post(settings.bestOfApi + "/update", JSON.stringify({
    bestOf: bestOf,
    title: titleBestoff,
    days: allDayBestOf,
    bestOfPosts: postByDay,
    postCover,
    isPublish: isPublish,
  }));
};

export default updateBestOf;
